/**
 * @generated SignedSource<<643c9a70c3a2870a6585b30c4f6e15f0>>
 * @relayHash 51d72511bd9f26d9675cbc0d2c8364ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 72829845c955a2a67b169e922457445d2504522cc78ee927edeb8e687333897f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useFieldNodeQuery$variables = {
  includeInstalledByAppName: boolean;
  includeIsForge: boolean;
  nodeId: string;
  skip: boolean;
};
export type useFieldNodeQuery$data = {
  readonly node?: {
    readonly __typename: "JiraIssueFieldConfig";
    readonly " $fragmentSpreads": FragmentRefs<"processFields">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type useFieldNodeQuery = {
  response: useFieldNodeQuery$data;
  variables: useFieldNodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeInstalledByAppName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeIsForge"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v11 = {
  "kind": "ScalarField",
  "name": "typeDisplayName"
},
v12 = {
  "condition": "includeInstalledByAppName",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "installedByAppName"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "description"
},
v14 = {
  "kind": "ScalarField",
  "name": "lastUsedTimestamp"
},
v15 = {
  "kind": "ScalarField",
  "name": "isLocked"
},
v16 = {
  "kind": "ScalarField",
  "name": "isCustom"
},
v17 = {
  "kind": "ScalarField",
  "name": "isGlobal"
},
v18 = {
  "kind": "ScalarField",
  "name": "isTrashed"
},
v19 = {
  "kind": "ScalarField",
  "name": "isUnscreenable"
},
v20 = {
  "kind": "ScalarField",
  "name": "customId"
},
v21 = {
  "kind": "ScalarField",
  "name": "associatedProjectsCount"
},
v22 = {
  "kind": "ScalarField",
  "name": "associatedScreensCount"
},
v23 = {
  "kind": "ScalarField",
  "name": "associatedContextsCount"
},
v24 = {
  "kind": "ScalarField",
  "name": "trashedTimestamp"
},
v25 = {
  "kind": "ScalarField",
  "name": "plannedDeletionTimestamp"
},
v26 = {
  "condition": "includeIsForge",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isForge"
    },
    {
      "kind": "ScalarField",
      "name": "isConnect"
    }
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v28 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "adminPagesFieldsIsHighlighted"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useFieldNodeQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "processFields",
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "trashedByUser",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v8/*: any*/),
                          (v27/*: any*/)
                        ]
                      },
                      (v28/*: any*/)
                    ],
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "includeInstalledByAppName",
                        "variableName": "includeInstalledByAppName"
                      },
                      {
                        "kind": "Variable",
                        "name": "includeIsForge",
                        "variableName": "includeIsForge"
                      }
                    ],
                    "argumentDefinitions": [
                      {
                        "defaultValue": false,
                        "kind": "LocalArgument",
                        "name": "includeInstalledByAppName"
                      },
                      {
                        "defaultValue": false,
                        "kind": "LocalArgument",
                        "name": "includeIsForge"
                      }
                    ]
                  }
                ],
                "type": "JiraIssueFieldConfig"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useFieldNodeQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "trashedByUser",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v8/*: any*/),
                      (v27/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  (v12/*: any*/),
                  (v26/*: any*/),
                  (v28/*: any*/)
                ],
                "type": "JiraIssueFieldConfig"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "72829845c955a2a67b169e922457445d2504522cc78ee927edeb8e687333897f",
    "metadata": {},
    "name": "useFieldNodeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5e2eb71a03324c505fbea112a2f13fcf";

export default node;
